import React from "react";
import { Step, StepButton, Stepper } from "@mui/material";

export default function ProgressStepper(props) {
  const { steps, activeStep, onStepClick, orientation } = props;
  const vertical = orientation === "vertical";

  return (
    <Stepper
      alternativeLabel={!vertical}
      orientation={vertical ? "vertical" : "horizontal"}
      activeStep={activeStep}
      sx={{
        "& .MuiStepIcon-root.Mui-completed": { color: "#16a085" },
        "& .MuiStepLabel-label": {
          fontSize: "12px",
          marginTop: vertical ? 0 : "10px",
          textTransform: "uppercase",
          fontWeight: "500",
          fontFamily: "inherit",
        },
      }}
    >
      {steps.map((o, idx) => (
        <Step key={idx}>
          <StepButton
            color="#000"
            disabled={!onStepClick}
            onClick={() => onStepClick && onStepClick(idx)}
          >
            {o}
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
}
